import {useEffect, useState} from 'react';
import {useAppSelector} from '@/hooks';
import {getColorsOnMyDesign} from '@Components/poster-editor/library/poster-editor-library';

export const useColorsOnMyDesign = (): string[] => {
  const isPosterReady = useAppSelector((state) => {
    return !!state.posterEditor.posterObject;
  });
  const [colors, setColors] = useState<string[]>(getColorsOnMyDesign);

  useEffect(() => {
    const poster = window.posterEditor?.whiteboard;
    if (!poster || !isPosterReady) {
      return undefined;
    }

    const updateColors = (): void => {
      setColors((prev) => {
        const next = getColorsOnMyDesign();
        if (prev.length === next.length && prev.every((color, index) => color === next[index])) {
          return prev;
        }
        return next;
      });
    };

    updateColors();
    poster.on('modified', updateColors);

    return (): void => {
      poster.off('modified', updateColors);
    };
  }, [isPosterReady]);

  return colors;
};
